import gql from 'graphql-tag';

export const includeExcludeMatriculasInAnalysis = gql`
  mutation includeExcludeMatriculasInAnalysis($matriculasIds: [String!]!, $include: Boolean!) {
    includeExcludeMatriculasInAnalysis(matriculasIds: $matriculasIds, include: $include) {
      id
      includedInAnalysis
    }
  }
`;

export const includeExcludeMatriculasInFormalization = gql`
  mutation includeExcludeMatriculasInFormalization(
    $matriculasIds: [String!]!
    $include: Boolean!
    $agFinancingId: String!
    $decisionSheetInput: UpdateDecisionSheetByReferenceInputSchema!
  ) {
    includeExcludeMatriculasInFormalization(
      matriculasIds: $matriculasIds
      include: $include
      agFinancingId: $agFinancingId
      decisionSheetInput: $decisionSheetInput
    ) {
      id
      includedInFormalization
    }
  }
`;
